<template>
  <div class="UserCenter">
    <div class="edit">
      <el-button
        type="primary"
        class="publicBtn"
        @click="routerLink('/UC/Center/CenterEdit')"
        >编辑</el-button
      >
    </div>
    <div class="user_avatar">
      <img class="user_img" :src="imgUrl" alt />
      {{ username }}
      <div class="user_town">{{ usertown }}</div>
    </div>
    <div class="user_information">
      <el-form label-width="47%" >
        <el-form-item v-for="info in userInformation" :label="info.key">
          <div class="info_label">{{ info.value }}</div>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="user_information">
      <ul class="information_detail">
        <li v-for="(item,index) of userInformation"
            :key="index">
          <div class="option">
            <span class="option_txt"
                  :title="item.key">{{item.key}}</span>
          </div>
          <div class="option_infor"
               :title="item.value">{{item.value}}</div>
        </li>
      </ul>
    </div> -->
    <!-- <el-button type="primary" @click="routerLink('/UC/Center/PsdEdit')">修改密码</el-button> -->
  </div>
</template>

<script>
import imgUrl from "@/assets/images/menuIcon/u@2x(1).png";
import { userDetail } from "common/js/api";

export default {
  data() {
    return {
      username: "",
      usertown: "湘江基金小镇",
      imgUrl,
      userInformation: [
        {
          key: "系统编号",
          value: "",
        },
        {
          key: "企业名称(全称)",
          value: "",
        },
        {
          key: "法定代表人姓名/委派代表姓名",
          value: "",
        },
        {
          key: "法定代表人/委派代表手机号",
          value: "",
        },
        {
          key: "联系人姓名",
          value: "",
        },
        {
          key: "联系人手机号",
          value: "",
        },
        {
          key: "邮箱",
          value: "",
        },
        {
          key: "账号申请时间",
          value: "",
        },
      ],
      userCode: "",
    };
  },

  created() {
    this.userCode = this.Cookies.get("identifyCode");
    if (this.userCode.substr(0, 1) == "WR") {
      this.userInformation = [
        {
          key: "系统编号",
          value: "",
        },
        {
          key: "姓名",
          value: "",
        },

        {
          key: "联系人手机号",
          value: "",
        },
        {
          key: "邮箱",
          value: "",
        },
        {
          key: "账号申请时间",
          value: "",
        },
      ];
    }
  },

  mounted() {
    this.getUserDetail();
  },

  methods: {
    routerLink(path) {
      this.$router.push(path);
    },

    async getUserDetail() {
      const res = await userDetail(this.userCode);
      console.log("res is ", res);
      if (res.result.registedType == "WR") {
        this.username = res.result.contactName;
        this.userInformation = [
          {
            key: "系统编号",
            value: res.result.identifyCode,
          },
          {
            key: "姓名",
            value: res.result.instition,
          },

          {
            key: "联系人手机号",
            value: res.result.contactTel,
          },
          {
            key: "邮箱",
            value: res.result.email,
          },
          {
            key: "账号申请时间",
            value: res.result.createdAt,
          },
        ];
      } else {
        const {
          instition,
          identifyCode,
          // contactTel,
          email,
          legalName,
          legalTel,
          contactName,
          contactTel,
          createdAt,
        } = res.result;
        this.username = contactName;
        this.userInformation[0].value = identifyCode;
        this.userInformation[1].value = instition;
        this.userInformation[2].value = legalName;
        this.userInformation[3].value = legalTel;

        this.userInformation[4].value = contactName;
        this.userInformation[5].value = contactTel;
        this.userInformation[6].value = email;
        this.userInformation[7].value = createdAt;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.UserCenter {
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  overflow: auto;
  flex-direction: column;
}

.user_avatar {
  display: flex;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 85px;
  position: relative;
  font-size: 24px;
  font-family: AlibabaM;
  color: #191818;
  line-height: 33px;
  .user_img {
    margin-bottom: 10px;
    width: 88px;
    height: 88px;
  }
  .user_town {
    margin-top: 6px;
    background: #e6f9ff;
    border-radius: 15px;
    padding: 4px 21px;
    font-size: 14px;
    font-family: AlibabaM;
    color: #008fff;
    line-height: 20px;
  }
}
.edit {
  position: absolute;
  top: 30px;
  right: 20px;
  bottom: 0;
  .el-button {
    position: relative;
    z-index: 2001;
  }
}
.user_information {
  margin: 60px 0 0 0;
  flex: 1;
  overflow: auto;
}
.el-form {
  .el-form-item {
    padding-bottom: 10px;
  }
  ::v-deep .el-form-item__label {
    font-size: 16px;
    font-family: Alibaba;
    color: #5f5f5f;
  }

  .info_label {
    font-size: 16px;
    font-family: AlibabaM;
    text-align: left;
    color: #191818;
    padding-left: 36px;
  }
}
</style>

